import { render, staticRenderFns } from "./CartSubmitFooter.vue?vue&type=template&id=4f483ebb&scoped=true&"
import script from "./CartSubmitFooter.vue?vue&type=script&lang=js&"
export * from "./CartSubmitFooter.vue?vue&type=script&lang=js&"
import style0 from "./CartSubmitFooter.vue?vue&type=style&index=0&id=4f483ebb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f483ebb",
  null
  
)

export default component.exports